export default __webpack_public_path__ + "static/media/customer.df73f247.svg";